import { addOfficeOrigin } from "../../../../../actions/Utilities/OfficeOrigin";
import { useMutation } from "react-query";

const useAddOfficeOrigin = () => {
  return useMutation(addOfficeOrigin);
};
export default useAddOfficeOrigin;
